<template>
  <div class="filters-container">
    <el-row :gutter="24">
      <custom-input
        v-model="filters.DescripcionInterna"
        :label="'Descripción'"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar descripción',
        }"
      ></custom-input>
      <el-col :span="4">
        <div class="custom-label">Familia Item</div>
        <el-select
          v-model="filters.Familias"
          multiple
          filterable
          remote
          reserve-keyword
          size="default"
          :remote-method="remoteSearchFamilias"
          :loading="loadingFamilias"
          clearable
          placeholder="Escribí para buscar familia"
          value-key="Codigo"
          :collapse-tags="true"
          :collapse-tags-tooltip="true"
          @clear="
            () => {
              filters.Familias = [];
              familiasOptions = [];
            }
          "
          @visible-change="onFamiliaVisible"
        >
          <el-option
            v-for="f in familiasOptions"
            :key="f.Codigo"
            :label="f.Descripcion"
            :value="f"
          />
          <template #empty>
            <div style="padding: 8px; color: #666">Escribí al menos 3 letras…</div>
          </template>
        </el-select>
      </el-col>

      <custom-select
        v-model="filters.MaterialTipos"
        :label="'Tipo Item'"
        :spanColumn="4"
        :settings="{
          placeholder: 'Seleccionar tipo de Item',
          options: materialTipoListFiltrado,
          multiple: true,
          filterable: true,
          clearable: true,
        }"
      ></custom-select>
      <custom-input
        v-model="filters.CodigoAdicional"
        :label="'Código Adicional'"
        :spanColumn="3"
        :settings="{
          placeholder: 'Ingresar código adicional',
        }"
      ></custom-input>

      <custom-select
        v-model="filters.GenericoFiltro"
        :label="'Genérico'"
        :spanColumn="3"
        :settings="{
          placeholder: 'Seleccionar',
          options: MaterialGenericoFiltroOptions,
          clearable: true,
        }"
      ></custom-select>

      <el-col
        :span="6"
        class="button-container"
      >
        <el-button
          type="primary"
          size="default"
          @click="filtrar"
          >Filtrar</el-button
        >
        <el-popover
          placement="right"
          :width="40"
          effect="dark"
          trigger="hover"
          content="Limpiar filtros"
        >
          <template #reference>
            <el-button
              type="danger"
              size="default"
              :icon="IconDelete"
              @click="LimpiarFiltros"
            ></el-button>
          </template>
        </el-popover>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import {
  ref,
  computed,
} from 'vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import { useMaterialStore } from '@/stores/materiales_store';
import { useMaterialTipoStore } from '@/stores/material-tipo.js';
import { useMateriaPrimaFamiliaStore } from '@/stores/materia_prima_familia/materia_prima_familia_store.js';
import { MaterialGenericoFiltroOptions } from '@/enum/material_generico_filtro.js';
import IconDelete from '~icons/mdi/delete';
import { storeToRefs } from 'pinia';

const materialStore = useMaterialStore();
const materialTipoStore = useMaterialTipoStore();
const materiaPrimaFamiliaStore = useMateriaPrimaFamiliaStore();
const { materialTipoList } = storeToRefs(materialTipoStore);
const { filters } = storeToRefs(materialStore);
const { resetMaterial, setPageMaterial, emptyList, findAllMaterialesHTTP, resetFilter } =
  materialStore;
const { searchMateriaPrimaFamiliaHTTP, listMateriaPrimaFamiliaTopHTTP } = materiaPrimaFamiliaStore;

const familiasOptions = ref([]);
const loadingFamilias = ref(false);

const materialTipoListFiltrado = computed(() => {
  return materialTipoList.value.filter((m) => m.Codigo !== 30);
});

const remoteSearchFamilias = async (query) => {
  loadingFamilias.value = true;
  try {
    familiasOptions.value = await searchMateriaPrimaFamiliaHTTP(query);
  } finally {
    loadingFamilias.value = false;
  }
};

const onFamiliaVisible = async (visible) => {
  if (!visible) return;
  if (familiasOptions.value.length) return;
  loadingFamilias.value = true;
  try {
    familiasOptions.value = await listMateriaPrimaFamiliaTopHTTP(20); // top 20 ordenados por descripción
  } finally {
    loadingFamilias.value = false;
  }
};

const normalizeFilterCodes = () => {
  filters.value.CodigosFamilia = Array.isArray(filters.value.Familias)
    ? filters.value.Familias.map((f) => f?.Codigo).filter(Boolean)
    : [];

  filters.value.tipos = Array.isArray(filters.value.MaterialTipos)
    ? filters.value.MaterialTipos.map((t) => t?.Codigo).filter(Boolean)
    : [];

  filters.value.filtroGenerico = filters.value.GenericoFiltro?.Codigo || undefined;

  if (typeof filters.value.DescripcionInterna === 'string') {
    const t = filters.value.DescripcionInterna.trim();
    filters.value.DescripcionInterna = t || null;
  }
};

const filtrar = () => {
  normalizeFilterCodes();
  resetMaterial();
  setPageMaterial(1);
  emptyList();
  findAllMaterialesHTTP({ 'tipos.ne': [30] });
};

const LimpiarFiltros = () => {
  setPageMaterial(1);
  emptyList();
  resetFilter();
  filtrar();
};
</script>

<style scoped>
.filters-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
}
.custom-label {
  font-weight: 700;
  color: #111;
}
.button-container {
  /* Estilo específico para el contenedor del botón */
  margin-top: auto; /* Empuja el contenido hacia abajo, ocupando la parte inferior */
}
.margin-row {
  margin-top: 1%;
}
</style>
